export default __webpack_public_path__ + "static/media/030-mermaid.5e2f0d9f.svg";